import { dbTrakingMenu } from '../db';

export const trackingMenu = {
  id: null,
  db: null,
  currentUrl:null,
  init: async function(){
    this.id = document.body.dataset.userId;
    this.currentUrl = document.querySelector("meta[name='current-url']")?.getAttribute('content') || null
    try {
      this.db = await dbTrakingMenu();
    } catch (error) {
      this.db = null;
      return this;
    }
    const { isRefresh, dados } = this.handleDOM() || {};
    if(dados && !isRefresh){
      this.updateCount(dados)
    }
    return this
  },
  updateCount: async function(data){
    const dataDB = await this.listMenus();
    if(dataDB){
      const index = dataDB.data.findIndex(item=>item.link === data.link);
      if(index > -1){
        dataDB.data[index] = { ...data, count: dataDB.data[index].count + 1 }
      } else {
        dataDB.data.push(data);
      }
      this.db.putData(this.id, dataDB.data);
    } else {
      this.db.putData(this.id, [data]);
    }
  },
  listMenus: async function(){
    if(!this.db) return;
    const dataDB = await this.db?.getData(this.id);
    return dataDB;
  },
  handleDOM: function(){
    const config = {
      dados: null,
      isRefresh: false
    }

    if(this.currentUrl && this.currentUrl !='/dashboard'){
      const menu = this.currentUrl;
      const menuAtivo = document.querySelector("#side-menu > .menu-ativo");
      if(!menuAtivo) return;
      const menuEl = menuAtivo.querySelector('.fa, .svg-icons-menus');
      const iconeMenu = menuEl?.classList?.value || '';
      let svgPath = ''
      if(menuEl && iconeMenu.match('svg-icons-menus')){
        svgPath = menuEl.dataset?.icon || ''
      }

      const dadosMenu = menuAtivo.querySelector(`.botao-submenu [href="${menu}"]`);
      if(dadosMenu){
        config.dados= {
          id: this.id,
          icon: iconeMenu,
          iconPath: svgPath,
          title: dadosMenu?.getAttribute('data-analytics-title')?.trim() || null,
          link: menu,
          count: 1
        }
      }
      config.isRefresh = this.isRereload()
    }

    return config;
  },
  isRereload: function(){
    return window.performance.getEntriesByType('navigation')
                              .map((nav) => nav.type)
                              .includes('reload')
  }
}
